export default "<!-- <p>default-redirect works!</p> -->\r\n";